module.exports = __webpack_public_path__ + "static/astigmatism-2024-efc0ad522ebc0b7bb5f299b13eeb861a.mp4";